import React from 'react';

function LoadingComponent() {
    const loadingIcon = require("../images/loading.gif");

    return (
        <div className="loadingComponentWrapper">
            <img className="loadingComponentIcon" src={loadingIcon} alt="loading"/>
        </div>
    );
};

export default LoadingComponent;